export default __webpack_public_path__ + "static/media/lemontbotanique_m2.64a84a0c.png";